import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"email\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M20 19H4a1 1 0 01-1-1V8l8.4 5.8.6.2c.2 0 .4 0 .6-.2L21 8V18c0 .6-.4 1-1 1zM4 5h16c.4 0 .7.2.9.6L12 11.8 3.1 5.6c.2-.4.5-.6.9-.6zm19 1a3 3 0 00-3-3H4a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol